import React from 'react';
import PropTypes from "prop-types";

import moment from 'moment';

import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'actions';


// react component for creating dynamic tables
import ReactTable from 'react-table';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Dvr from "@material-ui/icons/Dvr";
import Close from "@material-ui/icons/Close";
import EditIcon from '@material-ui/icons/Edit';
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import OrgSelector from "views/Orgs/OrgSelector.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import { reactTableDefaultProps } from 'helpers/reactTable';

import Modal from 'react-modal';
import { FORM_TYPE } from 'constants/form';
import { deleteDoc } from 'db';
import SweetAlert from 'react-bootstrap-sweetalert/lib/dist/SweetAlert';
import { Icon } from '@material-ui/core';
import DXFormViewerPrintable from 'components/Form/DXFormViewerPrintable';


const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    fontWeight: "bold"
  },
  textCenter: {
    textAlign: "center",
  }
};

const modalCustomStyles = {
  content: {
    top: '10%',
    left: '5%',
    right: '5%',
    bottom: '5%',
    backgroundColor: 'white',
    borderWidth: '1px',
    marginLeft: '260px',
    // transform: 'translate(-20%, -20%)',
  },
  overlay: {
    zIndex: 10,
    backgroundColor: 'rgba(255,255,255,0.4)'
  }
};

class DocManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      viewerModalIsOpen: false,
      currentDoc: null,
      currentOrg: null,
      unsubscribe: null,
      alert: null,
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.org && props.org.currentOrg !== state.currentOrg) {

      const org_id = props.org.currentOrg
        ? props.org.currentOrg.id
        : null;
      if (org_id) {
        if (state.unsubscribe) {
          state.unsubscribe();
        }
        return {
          currentOrg: props.org.currentOrg,
          unsubscribe: props.getDocsOfOrgAction(org_id)
        }
      }
    }
    return null;
  }

  componentDidMount() {
    Modal.setAppElement('#root');
  }

  componentWillUnmount() {
    if (this.state.unsubscribe) {
      this.state.unsubscribe();
    }
  }

  openModal = () => this.setState({ viewerModalIsOpen: true });
  closeModal = () => this.setState({ viewerModalIsOpen: false });
  requestClose = () => {
    console.log("closed!");
    this.closeModal();
  }
  afterOpenModal = () => {
    //Let us hide table
    // TODO Save
    console.log('Saved!');
  }


  render() {
    const { classes } = this.props;
    return (
      <GridContainer id="docManager">
        <OrgSelector color={this.props.color} />
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>사례관리</h4>
            </CardHeader>
            <CardBody>
              <ReactTable
                {...reactTableDefaultProps}
                data={this.props.docs}
                columns={[
                  {
                    id: 'reporter',
                    Header: "보고자",
                    accessor: d => d.data().reporter.displayName
                  },
                  {
                    id: 'formno',
                    Header: "서식번호",
                    accessor: d => d.data().form.서식,
                    sortMethod: (a, b) => {
                      const ta = a.replace("_", "").split("-");
                      const tb = b.replace("_", "").split("-");

                      if (ta[0] === tb[0]) {
                        return parseInt(ta[1] | 0) > parseInt(tb[1] | 0) ? 1 : -1
                      } else {
                        return parseInt(ta[0] | 0) > parseInt(tb[0] | 0) ? 1 : -1
                      }
                    }
                  },
                  {
                    id: 'formtitle',
                    Header: "서식제목",
                    accessor: d => d.data().form.평가도구
                  },
                  {
                    id: 'target',
                    Header: "대상",
                    accessor: d => d.data().target.name
                  },
                  {
                    id: "created_at",
                    Header: "생성일",
                    accessor: d => {
                      const created_at = d.data().created_at;
                      return moment(created_at ? created_at.toDate() : null).format('YYYY-MM-DD HH:mm:ss')
                    }
                  },
                  {
                    id: "action",
                    Header: "명령",
                    accessor: d => {
                      const doc = d.data();
                      return (
                        // we've added some custom button actions
                        <div className="actions-right">
                          {/* use this button to add a edit kind of action */}
                          <Button
                            justIcon
                            round
                            simple
                            onClick={() => {
                              if (doc.form_type === FORM_TYPE.CUSTOM) {

                              } else {
                                // go to form editing
                                this.props.setCurrentForm(doc.form);
                                this.props.history.push('/admin/wizard', { sku: doc.form.sku, doc, doc_id: d.id, target: doc.target });
                              }
                            }}
                            color="warning"
                            className="edit"
                          >
                            <EditIcon />
                          </Button>{" "}
                          <Button
                            justIcon
                            round
                            simple
                            onClick={() => {
                              this.setState({ currentDoc: doc });
                              this.openModal();
                            }}
                            color="warning"
                            className="edit"
                          >
                            <Dvr />
                          </Button>{" "}
                          {/* use this button to remove the data row */}
                          <Button
                            justIcon
                            round
                            simple
                            onClick={() => {
                              this.setState({
                                alert: (
                                  <SweetAlert
                                    warning
                                    style={{ display: "block", marginTop: "-100px" }}
                                    title="삭제 하시겠습니까?"
                                    onConfirm={() => {
                                      const org_id = this.props.org.currentOrg.id;
                                      const doc_id = d.id;
                                      return deleteDoc(org_id, doc_id)
                                        .then(() => {
                                          this.setState({
                                            alert: null
                                          });
                                          return this.props.showAlertAction({
                                            message: `삭제되었습니다.`,
                                            color: 'danger',
                                          })
                                        })
                                    }}
                                    onCancel={() => this.setState({
                                      alert: null
                                    })}
                                    confirmBtnCssClass={
                                      this.props.classes.button + " " + this.props.classes.success
                                    }
                                    cancelBtnCssClass={
                                      this.props.classes.button + " " + this.props.classes.danger
                                    }
                                    confirmBtnText="네 삭제합니다."
                                    cancelBtnText="취소"
                                    showCancel
                                  >
                                    한번 삭제하면 복구가 불가능합니다.
                                  </SweetAlert>
                                )
                              })
                            }}
                            color="danger"
                            className="remove"
                          >
                            <Close />
                          </Button>{" "}
                        </div>
                      )
                    },
                    sortable: false,
                    filterable: false
                  }
                ]}
              />
            </CardBody>
          </Card>
        </GridItem>

        <Modal
          isOpen={this.state.viewerModalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.requestClose}
          style={modalCustomStyles}
          contentLabel="문서보기"
        >
          <DXFormViewerPrintable
            {...this.props}
            doc={this.state.currentDoc}
            onClose={this.closeModal}
          />
        </Modal>

        {this.state.alert}
      </GridContainer>
    );
  }
}


DocManager.propTypes = {
  classes: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
    docs: state.doc.docs,
    org: state.org,
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(actions, dispatch);
}


export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(DocManager);